// extracted by mini-css-extract-plugin
module.exports = {"title":"ConfirmModal_title__2ING3","content":"ConfirmModal_content__2f9RB","buttonPane":"ConfirmModal_buttonPane__Rp93c"};